import { render } from "./CookiesCatalogItemCard.vue?vue&type=template&id=0df13412&scoped=true&ts=true"
import script from "./CookiesCatalogItemCard.vue?vue&type=script&lang=ts"
export * from "./CookiesCatalogItemCard.vue?vue&type=script&lang=ts"

import "./CookiesCatalogItemCard.vue?vue&type=style&index=0&id=0df13412&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df13412"]])

export default __exports__